import { createEffect } from 'effector'
import type { ApiEffect } from '../../index.h'

//POST /v3/device/push_token
export const pushTokenFx: ApiEffect<string, void> = createEffect()
